import createInformesSectionPage from "./SectionPageFactory";

const InformesLogisticaPage = createInformesSectionPage(
  "Logística",
  "Evaluá el desempeño de envíos, entregas y costos asociados a la cadena logística."
);

export default InformesLogisticaPage;
